export default class Pagination {
    public totalRows = 0;
    public page = 0;
    public pageSize = 0;
    public hasMore = true;
}
